import isAuthenticated from './isAuthenticated';
import hasRoles from './hasRoles';
import isActiveMember from './member/isActive';
import redirectIfAuthenticated from './redirectIfAuthenticated';

export default function (router) {
    redirectIfAuthenticated(router)
    isAuthenticated(router);
    hasRoles(router);
    isActiveMember(router);
}